import type { User } from '@/models/User'

interface TokenResponse {
  accessToken: string
  refreshToken: string
  tokenType: string
  expiresIn: number
  expiresAt: string
  roles: string[]
}

export class AuthService {
  async login(username: string, password: string): Promise<{ token: string; refreshToken: string; roles: string[] }> {
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    })

    if (!response.ok) {
      throw new Error('Invalid credentials')
    }

    const data: TokenResponse = await response.json()
    return {
      token: data.accessToken,
      refreshToken: data.refreshToken,
      roles: data.roles
    }
  }

  async getCurrentUser(): Promise<User> {
    const token = localStorage.getItem('authToken')
    const response = await fetch('/api/auth/me', {
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (!response.ok) {
      throw new Error('Failed to get current user')
    }

    return response.json()
  }

  async logout(): Promise<void> {
    const token = localStorage.getItem('authToken')
    if (!token) return
    await fetch('/api/auth/logout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(token)
    }).catch(() => {})
  }

  async refresh(token: string, refreshToken: string): Promise<{ token: string; refreshToken: string }> {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, refreshToken })
    })

    if (!response.ok) {
      throw new Error('Token refresh failed')
    }

    const data: TokenResponse = await response.json()
    return { token: data.accessToken, refreshToken: data.refreshToken }
  }
}
